import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { rejects } from 'assert';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})

export class GeocodingAddressService {

	private staticApiURL = 'https://maps.googleapis.com/maps/api/staticmap'
	geocoder: google.maps.Geocoder;
	// apiKey = environment.mapsKey

	constructor(private http: HttpClient) {
		this.geocoder = new google.maps.Geocoder();
	}

	geoCodingAddress(address: string): Promise<any> {

		return new Promise((resolve, reject) => {
			this.geocoder.geocode({ 'address': address }, (result, status) => {
				if (status == 'OK') {
					resolve(result)
				} else {
					console.log(`Geocode was not successful for the following reason: ${status}`)
					reject(`Geocode was not successful for the following reason: ${status}`)
				}
			})
		})
	}

	reverseGeoCodingAddress(lat: number, lng: number) {
		const latLng = { lat, lng }

		return new Promise((resolve, reject) => {
			this.geocoder.geocode({ 'location': latLng }, (result, status) => {
				if (status == 'OK') {
					resolve(result)
				} else {
					console.log(`Geocode was not successful for the following reason: ${status}`)
					reject(`Geocode was not successful for the following reason: ${status}`)
				}
			})
		})

	}


	// getCenterMap(lat, lng) {
	// 	const params = {
	// 		key: this.apiKey,
	// 		center: `${lat},${lng}`,
	// 		zoom: '15',
	// 		size: '1024x750',
	// 		markers: `color:red%7C${lat},${lng}`
	// 	}

	// 	const parseParams = Object.keys(params).map(key => `${key}=${params[key]}`).join('&')

	// 	return `${this.staticApiURL}?${parseParams}`
	// }


}
